import { useContext, useCallback } from 'react';
import { useHistory, useLocation } from "react-router-dom";

import { TransitionContext } from '../Context/TransitionContext';

function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

const openInNewTab = (url) => {
  const newWindow = window.open(url, '_blank', 'noopener,noreferrer');
  if (newWindow) newWindow.opener = null;
}

const colorPages = ["/", "/certified", "/standard", "/documents", "/languages", "/use-cases", "/use-cases/business-document-translation-services", "/about", "/jobs"];

// The router's history that is mounted now. The whole router can be created
// again while a transition is under way (right after signing in the tree
// above it re-renders and a new router, with a new history, takes over), and a
// `transitionTo` made before that holds the old history: pushing to it changes
// the address bar but the page shown never changes (the person stays on the
// home page with /account/orders in the address, 2026-10-10). So transitions
// push to this one. <HistoryTracker /> is mounted once inside the router.
let liveHistory = null;
export const HistoryTracker = () => {
  liveHistory = useHistory();
  return null;
};

const useScreenTransition = () => {

  const { setShowTransitionOverlay, setColor } = useContext(TransitionContext);

  const history = useHistory();


  const transitionTo = useCallback((path, e) => {
    if(e && e.ctrlKey){
      openInNewTab(path)
      return;
    }
    
    setShowTransitionOverlay(true);
    sleep(100).then(() => {
      if (window.innerWidth > 1024 && (colorPages.some(p => p === path) || path.startsWith("/document/") || path.startsWith("/language/") || path.startsWith("/use-case/"))) {
        setColor(false);
      } else {
        setColor(true);
      }
      
      (liveHistory || history).push(path);
      window.document.documentElement.scrollTop = 0;
      setShowTransitionOverlay(false);
    })
  }, [setShowTransitionOverlay, history, setColor]);

  
  
  return { transitionTo };
  
}

const getQueryParam = (param) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  return queryParams.get(param);
}


export { useScreenTransition, getQueryParam };